export const postLoginKYC =
  'You have not yet completed your profile. You will need to complete your profile before you can invest through Seedbox. Would you like to complete your profile now?';
export const postLoginFATCA =
  'You have not yet completed your profile. You will need to complete your profile before you can invest through Seedbox. Would you like to complete your profile now?';
export const postLoginRiskProfile =
  'You have not yet completed your profile. You will need to complete your profile before you can invest through Seedbox. Would you like to complete your profile now?';
